import { withTranslation } from "next-i18next";
import Offcanvas from "../Offcanvas";
import QuickAddToClosetOffCanvasVariants from "./QuickAddToClosetOffCanvasVariants";

function QuickAddToClosetOffCanvas({ show, onHide, productWithVariants, dataFromAlgolia, t }) {
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="bottom"
      title={t("common:quick_add_to_closet.offcanvas.title")}
    >
      <QuickAddToClosetOffCanvasVariants
        productWithVariants={productWithVariants}
        onHide={onHide}
        dataFromAlgolia={dataFromAlgolia}
      />
    </Offcanvas>
  );
}

export default withTranslation("common")(QuickAddToClosetOffCanvas);
